const formId = 'marketing-form';

const formEl = document.getElementById(formId);

// Function to track input field on blur event
const onInputFilled = (ele) => {
  try {
    const fieldName = ele?.name;
    const fieldData = ele?.value;

    if (!fieldData) return;

    if (window.GTMtracker) {
      window.GTMtracker.pushEvent({
        event: 'gtm_custom_click',
        data: {
          click_type: 'form_input_filled',
          click_text: fieldName,
          click_source: 'upfront_form',
          form_id: formId,
        },
      });
    }
  } catch (e) {
    // Suppress error
  }
};

// Function to initialize input tracking
const initializeTracking = () => {
  // Select input elements with 'form-input' class
  const formInputEls = formEl?.querySelectorAll('input.form-input');
  [...formInputEls].forEach((ele) => {
    ele.addEventListener('blur', () => {
      onInputFilled(ele);
    });
  });

  // Select input elements with 'sr-select__value-input' class
  const selectInputEls = formEl?.querySelectorAll(
    'input.sr-select__value-input:not([name="country_code"])',
  );
  [...selectInputEls].forEach((ele) => {
    ele.addEventListener('input', () => {
      onInputFilled(ele);
    });
  });
};

export default {
  initialize: initializeTracking,
};
